import { RepositoryFactory } from '../repositories/PassageApi/RepositoryFactory.js'
import CredentialsService from '../services/CredentialsService.js'

const ServicesRepository = RepositoryFactory.get('service')

class ServiceService {
  static async getServices (params) {
    try {
      return await ServicesRepository.getServices(CredentialsService.getCurrentTenantId(), params)
    } catch (error) {
      console.log(error)
    }
  }

  static async getService (serviceId, params) {
    try {
      return await ServicesRepository.getService(CredentialsService.getCurrentTenantId(), serviceId, params)
    } catch (error) {
      console.log(error)
    }
  }

  static async updateService (serviceId, data) {
    try {
      return await ServicesRepository.updateService(CredentialsService.getCurrentTenantId(), serviceId, data)
    } catch (error) {
      console.log(error)
    }
  }

  static async createService (data) {
    try {
      return await ServicesRepository.createService(CredentialsService.getCurrentTenantId(), data)
    } catch (error) {
      console.log(error)
    }
  }

  static async getServiceGroups (serviceId, params) {
    try {
      return await ServicesRepository.getServiceGroups(serviceId, params)
    } catch (error) {
      console.log(error)
    }
  }

  // static async getResultHorseExercise (horseId, exerciseId, params) {
  //   try {
  //     return await HorsesRepository.getResultHorseExercise(CredentialsService.getCurrentTenantId(), horseId, exerciseId, params)
  //   } catch (error) {
  //     console.log(error)
  //   }
  // }
}

export default ServiceService
